import { defineMessages } from 'react-intl';

export const LOCALIZED_STRINGS = defineMessages({
    InsuranceModalHeader: {
        id: 'Practice.Components.InNetworkInsurances.ModalHeader',
        defaultMessage: 'In-network insurances',
    },
});
